<h2 mat-dialog-title>
    {{ 'polls_settings.trend_results_dialog.title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10 poll-aggregated-results">  
    @if(error){
        <p class="text-secondary pb-2"><i class="fa-solid fa-exclamation-circle"></i> {{ 'polls_settings.loading_error' | translate}}</p>
    } @else if(!poll){
        <p class="text-secondary pb-2"><i class="fa-solid fa-circle-notch fa-spin"></i> {{ 'polls_settings.loading' | translate}}</p>
    } @else {
        <div class="row px-5">
            <h3 class="col-md-8 mx-auto text-center text-secondary fw-normal fst-italic fs-5 py-3">
                {{poll?.label}}
            </h3>
        </div>
        <div class="row gx-4 pb-5 px-5">
            <div class="col-md-7">
                @if(poll.allResults?.values){
                    @switch(poll.itemType){
                        @case('closedQuestionResultItem'){
                            <recurring-closed-poll-result-trends-chart [series]="allTeamsAverageSerie"
                                                                       [dates]="dates"
                                                                       [chartId]="'trends-'+data.pollAggregateId"></recurring-closed-poll-result-trends-chart>
                        }
                        @default{
                            <recurring-poll-result-trends-line-chart [dates]="dates"
                                                                     [series]="series"
                                                                     [chartId]="'trends-'+data.pollAggregateId"></recurring-poll-result-trends-line-chart>
                        }
                    }
                }
            </div>
            <div class="col-md-5 d-flex flex-column justify-content-center align-items-center">
                <div class="alert alert-light p-4">
                    <p class="pb-2">
                        {{ 'polls_settings.aggregate_results_dialog.question_asked' | translate }} @if(poll?.displayAuthor){
                        {{ 'by' | translate }} <span class="fst-italic">{{poll?.author.fullname}}</span>
                        } 
                        {{'polls_settings.aggregate_results_dialog.target' | translate}}<br>
                        @for(teamName of data?.teams; track teamName; let last= $last){
                            <span class="badge border text-bg-light my-1 ms-0" [ngClass]="{'me-1': !last}">
                                {{teamName}}
                            </span>
                            @if(!last){,&nbsp;}
                        }.
                    </p>
                    @switch(poll.itemType){
                        @case('closedQuestionResultItem'){
                            <p class="pb-2">{{ 'trend_average_graph_legend_percentage_closed_desc1' | translate}}</p>
                        }
                        @case('scaleQuestionResultItem'){
                            <p class="pb-2">{{'trend_all_team_average_graph_legend.scale_desc1' | translate}} <b>{{orderedValues[4]?.label}}</b> {{'trend_all_team_average_graph_legend.scale_desc2' | translate}} <b>{{orderedValues[0]?.label}}</b> (5).</p>
                        }
                        @case('agreeDisagreeQuestionResultItem'){
                            <p class="pb-2">{{'trend_all_team_average_graph_legend.scale_desc1' | translate}} <b>{{orderedValues[4]?.label}}</b> {{'trend_all_team_average_graph_legend.scale_desc2' | translate}} <b>{{orderedValues[0]?.label}}</b> (5).</p>
                        }
                        @case('fiveStarsQuestionResultItem'){
                            <p class="pb-2">{{'trend_average_graph_legend_percentage.five_stars_desc1' | translate}}</p>
                        }
                    } 
                    <p>{{ 'poll_results.trends_desc1' | translate }} <b>{{poll.allResults.recurrenceType | translate }} ({{poll.allResults.dates.length}} {{ 'poll_results.trends_desc2' | translate }})</b>.</p>
                    @if(nullSeries > 0){
                        <p>{{'poll_results.trends_desc.no_data' | translate: {nullSeries: nullSeries} }}</p>   
                    }
                </div>
            </div>
        </div>

        <!-- Details by Team -->
        @if((poll.itemType === 'closedQuestionResultItem') && poll?.allResults?.values?.length > 1){
            <div class="mx-3 details-divider">
                <p class="fst-italic text-secondary pb-2">{{'polls_settings.aggregate_results_dialog.details'| translate}}</p>
            </div>
            <div class="tabs-wrapper">
                <mat-tab-group>
                        <mat-tab label="{{'polls_settings.aggregate_results_dialog.byteam' | translate}}"> 
                            <ng-template matTabContent>
                                <div class="row pt-3">
                                        @for(teamOccurences of series; track $index){
                                            <div class="col-md-4">
                                                <p class="fw-bold text-center text-secondary">{{teamOccurences.name}}</p>
                                                @if(teamOccurences?.data){
                                                    <recurring-closed-poll-result-trends-chart [series]="teamOccurences"
                                                                                            [dates]="dates"
                                                                                            [chartId]="'trends-'+data.pollAggregateId+'-' + $index"></recurring-closed-poll-result-trends-chart>
                                                }
                                            </div>
                                        }
                                </div>
                            </ng-template>
                        </mat-tab>    
                        </mat-tab-group>   
                    </div> 
            }
    }
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'close' | translate}}</button>
</mat-dialog-actions>